var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0653 2C15.4867 1.99945 13.9742 2.63372 12.8682 3.76007L12.0034 4.64349L11.1301 3.75838C10.0231 2.63381 8.51106 2.00053 6.93303 2.00053C5.35499 2.00053 3.84297 2.63381 2.73593 3.75838C0.421356 6.12064 0.421356 9.90031 2.73593 12.2626L12.0034 21.6434L21.2641 12.2626C23.5786 9.90031 23.5786 6.12064 21.2641 3.75838C20.1574 2.63223 18.6442 1.99854 17.0653 2Z",
    fill: "#121212"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart.15dad6c78e0f7311899ef20eae91cfaf.svg";